/**
 * Updates the global CSS variables that define the flavor colors
 * based on the provided trigger element's dataset attributes.
 *
 * @param {HTMLElement} trigger - The trigger element that contains the
 * color data in its dataset attributes. It should have the following
 * properties: 'data-color-light', 'data-color-medium', 'data-color-dark'.
 */

export const updateColors = (trigger) => {
  document.documentElement.style.setProperty(
    "--flavor-color-100",
    `${trigger.dataset.colorLight}`
  );
  document.documentElement.style.setProperty(
    "--flavor-color-200",
    `${trigger.dataset.colorMedium}`
  );
  document.documentElement.style.setProperty(
    "--flavor-color-300",
    `${trigger.dataset.colorDark}`
  );
  document.documentElement.style.setProperty(
    "--flavor-color-selector",
    `${trigger.dataset.colorSelector}`
  );
};
